import React, { useEffect } from "react";
import Translate, { useTranslate } from "../Translate/Translate";

//import  './TableFooter.css';
import    './FooterTable.css'

const TableFooter = ({ range, setPage, page, slice }) => {
  useEffect(() => {
    if (slice.length < 1 && page !== 1) {
      setPage(page - 1);
    }
    

  }, [slice, page, setPage]);
  return (
    <div className="tableFooter">      
      {page>1 && <button className="prevButton actionButton" aria-label={<Translate>PrevPage</Translate>} onClick={() => setPage(page-1)}></button>}
      {
        range.map((el, index) => (
        <>
        { 
           index > page-4 && index < page+2 &&
        <button
          key={index}
          className={`button ${
            page === el ? "activeButton" : "inactiveButton"
          }`}
          onClick={() => setPage(el)}
        >
          {el}
        </button>
      }
    </>
      ))}
     {page<range.length && <button className="nextButton actionButton" aria-label={<Translate>NextPage</Translate>} onClick={() => setPage(page+1)}></button>}
     
    </div>
  );
};

export default TableFooter;